import { ContentBlock } from '@/components/ContentBlock';
import { ContentMedia } from '@/components/ContentVideoBlock';
import { SlideData } from '@/components/kie-ev5-campaign/carousel';

export const heroEV5 = {
  title: 'Kia EV5. Med Pausläge.',
  subTitle: 'Friheten väntar.',
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/Clean%20EV5_topp_kia-com.mp4',
  mobileSrc:
    'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/CLEAN_OLV_10s_EV5_hero_feb_GENERELL_9_16_reel_MASTER_V1_260120.mp4',
  srcWebm: '',
};
export const introEV5 = {
  heading: 'Kia EV5. Friheten väntar.',
  headingSub: 'Rek. ca pris från 553 900kr.',
  text: 'Upptäck Kia EV5 — en helt ny el-SUV som kombinerar innovativ teknik med imponerande utrymmen och förstklassig komfort. Med det smarta pausläget håller bilen rätt temperatur hela natten — perfekt för äventyret på fjället eller en spontan övernattning var du än är. Välkommen in och upplev Kia EV5.',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-890x240px-x2.jpg',
    alt: 'En silverfärgad Kia EV5 med takbox parkerad i ett storslaget, snötäckt fjällandskap. Bredvid bilen sitter en person och en hund vid en snowboard och blickar ut över de vintriga bergen i solnedgången.',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'w-full min-h-[200px] object-cover',
  },
  link: {
    url: 'https://www.kia.com/se/nya-bilar/ev5/upptack/',
    text: 'Läs mer om Kia EV5',
  },
};

export const textBoxicon01 = {
  title: '',
  backgroundColor: '',
  numberOfFields: 3,
  titleStyle: 'mb-6 text-[32px] max-w-[627px]',
  textSize:
    'text-center leading-[24px] text-[16px] md:text[18px] font-light md:font-normal',
  listItems: [
    {
      subtitle: 'Klassledande utrymme och komfort',
      text: 'Stort bagageutrymme, relaxationstolar fram och gott om benutrymme bak.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      subtitle: 'Modern teknik',
      text: 'Aktivera pausläget och använd allt från Vehicle-to-Load, infotainment och klimatanläggning när bilen står parkerad.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      subtitle: 'Tryggt och säkert',
      text: 'De senaste förarassistanssystemen, inklusive autobromsfunktioner, adaptiv farthållare och parkeringsassistans.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
  ],
};

export const featuresEV5: ContentMedia[] = [
  {
    title: 'Bilen som basläger.',
    layout: 'row',
    text: 'Tack vare pausläget kan du använda Kia EV5 i stillastående läge. I pausläget använder bilen högvoltsbatteriet för att hålla funktioner i gång. Bilen kan inte köras men alla elektriska enheter kan användas, som klimatanläggning, infotainmentsystem, USB-uttag, innerbelysning, fram- och bakljus och Vehicle-to-Load (V2L). Under filminspelningen i Storulvån användes stillastående läge i 8 timmar i minus 10 grader och då användes 6% av högvoltsbatteriet. (Siffran är bara en indikation vid detta tillfälle. Faktisk förbrukning beror bl.a. på yttertemperaturen.)',
    video: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia%20EV5%20A%CC%8Are%2060s%2016x9.mp4',
    },
    videoMobile: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia_EV5_A%CC%8Are_60s_9X16_CLEAN.mp4',
    },
    thumbnail: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5_baslager_1400.png',
      alt: 'En person på turstegel skidar uppför en snötäckt fjällsida tillsammans med en hund i ett gyllene kvällsljus.',
    },
  },
  {
    title: 'Plats för äventyr.',
    layout: 'col',
    text: 'Med hög komfort och stora utrymmen är Kia EV5 ett perfekt val för alla resor, oavsett längd. Njut av relaxationstolar fram, klassledande benutrymme bak och möjlighet att fälla den bakre sätesraden helt plant för att ge plats åt mer packning eller en madrass att sova på.',
    video: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia%20EV5%20A%CC%8Are%20A%CC%88ventyret%2016X9.mp4',
    },
    videoMobile: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia_EV5_A%CC%8Are_A%CC%88ventyret_9X16_CLEAN.mp4',
    },
    thumbnail: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/Kia_EV5_swe_dec_2025__CJ__MG_8713_v2_1200.jpg',
      alt: 'Mysig stämning med en hund som vilar på ett mjukt täcke i bagageutrymmet på en Kia EV5 under en bilutflykt eller campingtur i vintermiljö.',
    },
  },
  {
    title: 'Med hjärtat i Jämtland.',
    layout: 'col',
    text: '“Jämtland är min lekplats och bakgården där jag växte upp. Men ändå hann jag utforska resten av världen innan jag på allvar upptäckte Jämtland. Den svenska fjällvärlden kräver ganska mycket av åkarna, det är tjorvigt och stundtals otillgängligt — men kan som ingen annanstans ge mig aha-upplevelser och storslagna ögonblick" Tom-Oliver Hedvall',
    boldText: ['Tom-Oliver Hedvall'],
    link: {
      url: 'https://story.kia.se/tom-oliver-hedvall-med-hjartat-i-jamtland',
      text: 'Läs mer om Tom-Oliver Hedvall ',
    },
    thumbnail: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_6725.jpg',
      alt: 'En person och en hund sitter bredvid en silverfärgad Kia EV5 med snowboard och ett vintrigt fjäll i bakgrunden.',
    },
    video: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia%20EV5%20x%20Tom-Oliver%20Hedvall.%20Livet%20med%20bilen.mp4',
    },
    videoMobile: {
      src: '',
    },
  },
];

export const hero2EV5 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/kia-ev5-directors-cut.mp4',
};
export const CarouselEV5: SlideData[] = [
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_6725.jpg',
      alt: 'En person och en hund sitter bredvid en silverfärgad Kia EV5 med snowboard och ett vintrigt fjäll i bakgrunden.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_7062.jpg',
      alt: 'Närbild i profil på en person och en engelsk setter som blickar ut över ett snötäckt landskap.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_7311.jpg',
      alt: 'En person och en hund sover tillsammans i det bäddade bagageutrymmet på en Kia EV5, upplyst av en lykta.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_7696.jpg',
      alt: 'Vy uppifrån genom bilens panoramatak som visar en person och en hund som vilar i det varma skenet inuti kupén.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8367.jpg',
      alt: 'En person förbereder sängplatsen i bakluckan på en Kia EV5 under en vintercamping.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8398.jpg',
      alt: 'En person tänder en fotogenlykta i baksätet på en Kia EV5 för att skapa en mysig stämning inför natten.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8673.jpg',
      alt: 'Närbild på en person som använder ett våffeljärn i bagageutrymmet på en Kia EV5, med hunden vilande i bakgrunden.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8713_v2.jpg',
      alt: 'En engelsk setter vilar på ett mjukt täcke i det öppna bagageutrymmet på en Kia EV5 i vintermiljö.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8785.jpg',
      alt: 'En person sitter i bakluckan på en Kia EV5 och äter en smörgås tillsammans med sin hund i ett snöigt landskap.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_9044.jpg',
      alt: 'En person och en hund ligger nedbäddade i bakluckan på en Kia EV5 och tittar ut genom rutan mot vinterkvällen.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/KIA_EV5_FRONT_FINAL_CAR.jpg?v=2',
      alt: ' En silverfärgad Kia EV5 parkerad framför ett snötäckt fjäll under en klarblå vinterhimmel.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/KIA_EV5_REAR_FINAL_TAKBOX%2BTOM.jpg?v=2',
      alt: 'En person och en hund står bredvid en Kia EV5 utrustad med takbox och snowboard i ett vidsträckt fjällandskap.',
    },
  },
  {
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/KIA_EV5_SIDE_DAY_FINAL_TAKBOX%2BTOM.jpg?v=2',
      alt: 'Kia EV5 med takbox parkerad på en isig väg i fjällen med en person, en hund och en snowboard i förgrunden.',
    },
  },
];
export const contentBlocksEV5: ContentBlock[] = [
  {
    title: 'Snabbladdning och utrustningsnivåer.',
    text: 'Kia EV5 kommer med en räckvidd på upp till 530 km. Tack vare 400V-tekniken och möjlighet att förvärma högvoltsbatteriet på 81,4 kWh kan bilen snabbladdas 10–80 % på ner till 30 minuter. Kia EV5 erbjuds i tre utrustningsnivåer: Kia EV5, Kia EV5 Plus och Kia EV5 GT Line, de två senare kan fås med fyrhjulsdrift (AWD).',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-2-590x400-x2.jpg',
      alt: 'En person och en hund sitter tillsammans i den öppna bakluckan på en Kia EV5 och blickar ut över ett vidsträckt, vintrigt fjällandskap under en paus på bilresan.',
      sizes: '(max-width: 768px) 100vw, 50vw',
      className: '',
    },
    link: {
      url: 'https://www.kia.com/se/nya-bilar/ev5/upptack/#charging-range',
      text: 'Läs mer om laddning',
    },
  },
  {
    title: 'Så aktiverar du pausläget.',
    list: [
      'Tryck på "elfordon” på hemskärmen (syns inte denna knapp vid kartan/mediaspelaren på hemskärmen, svajpa åt vänster).',
      'Tryck på EV-inställningar (det lilla kugghjulet nere till höger).',
      'Välj ”Stillastående läge”.',
    ],
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-2-590x400-x3.jpg',
      alt: 'En person och en hund sitter inne i en bil på kvällen framför en tänd laptopskärm med vintermiljö i bakgrunden.',
      sizes: '(max-width: 768px) 100vw, 50vw',
      className: '',
    },
    link: {
      url: 'https://story.kia.se/pauslage-i-kia-ev5-anvand-bilen-nar-den-star-still',
      text: 'Läs mer om hur pausläget fungerar',
    },
  },
  {
    title: 'Pet mode: nu i Kia EV5.',
    text: 'Med Pet mode i Kia EV5 blir det enklare att ta med dina fyrfota vänner i bilen. Lämna ditt djur i bilen med låsta dörrar och klimatanläggningen på i önskad temperatur. Infotainmentsystemet visar förbipasserande att djuret har det bra. Som en extra garant kan även du följa bilens temperatur direkt i telefonen, via Kia App.',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-interior.jpg',
      alt: 'Interiören i en Kia EV5 där den digitala instrumentpanelen visar "Husdjursläge" aktiverat. På skärmen syns en söt animation och texten "Jag väntar på min husse/matte" samt en inställd temperatur på 20 grader, med ett snöigt landskap utanför vindrutan.',
      sizes: '(max-width: 768px) 100vw, 50vw',
      className: '',
    },
    link: {
      url: 'https://story.kia.se/husdjurslage-och-3-andra-tips-till-dig-med-djur-i-bil',
      text: 'Läs mer om Pet mode',
    },
  },
  {
    title: 'Kia EV5 Business Edition.',
    text: 'Med Kia Business Edition får du Kia EV5 i fullutrustat GT Line-utförande, till attraktivt förmånsvärde. Upptäck alla fördelar med Kia Business Edition.<br><br>Rek. ca pris från 569 900 kr.<br>Förmånsvärde från 2 604 kr/mån.',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-2-590x400-x4.jpg',
      alt: 'Närbild på den karakteristiska LED-strålkastaren och fronten på en silverfärgad Kia EV5, med ett suddigt vintrigt fjällandskap i bakgrunden som framhäver bilens moderna desi',
      sizes: '(max-width: 768px) 100vw, 50vw',
      className: '',
    },
    link: {
      url: 'https://www.kia.com/se/tjanstebil/business-edition/',
      text: 'Läs mer om Kia Business Edition',
    },
  },
];

export const hero3EV5 = {
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-Hero2.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: '',
  },
};

export const infoBoxEV5 = {
  title: 'Enkel finansiering.',
  text: 'Att köpa och finansiera sin bil ska vara enkelt, förmånligt och tryggt. Därför erbjuder vi flexibla och skräddarsydda finanslösningar som kan göra ditt bilägande ännu smidigare.',
  links: [
    {
      text: 'Hitta närmaste återförsäljare',
      url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
      className: 'border-2 border-black',
      openInNewTab: true,
      textColor: 'black',
      bgColor: 'white',
    },
    {
      text: 'Prislista',
      url: 'https://www.kia.com/se/kopa/prislista/',
      className: 'w-[298px]',
      openInNewTab: true,
    },
  ],
};

export const infoColumnsEV5 = [
  // {
  //   title: 'Finansiera din tjänstebil',
  //   text: 'Kia Business Lease är en helhetslösning som innebär ett garanterat restvärde. Med Kia Finansiell leasing väljer du själv till de tjänster du behöver.',
  //   titleClasses: 'font-medium text-2xl',
  //   textClasses: 'font-light',
  //   textContainerClasses: 'text-center',
  //   image: {
  //     src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-300x400-1.jpg',
  //     alt: 'KIA Elbilar',
  //     sizes: '(max-width: 768px) 100vw, 50vw',
  //   },
  //   link: {
  //     text: 'Våra finansieringslösningar',
  //     url: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
  //     openInNewTab: false,
  //   },
  // },
  {
    title: 'Kia som tjänstebil.',
    text: 'Med en Kia som tjänstebil får du innovativ teknik, uppkopplade tjänster, hög komfort och de senaste säkerhetssystemen. Alltid med flexibla finansieringslösningar.',
    titleClasses: 'font-medium text-2xl',
    textClasses: 'font-light',
    textContainerClasses: 'text-center',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/KIA_EV5_SIDE_kamp_tjanstebil_1200.jpg',
      alt: 'En silverfärgad Kia EV5 sedd snett bakifrån, parkerad på en isig väg i ett dramatiskt fjällandskap. Bilen är utrustad med en takbox och dess karakteristiska bakljus är tända mot de snöklädda bergen i bakgrunden.',
      sizes: '(max-width: 768px) 100vw, 50vw',
    },
    link: {
      text: 'Läs mer om Kia som tjänstebil',
      url: 'https://www.kia.com/se/tjanstebil/',
      openInNewTab: false,
    },
  },
  {
    title: 'Räkna på din nästa tjänstebil.',
    text: 'I vår tjänstebilskalkylator kan du jämföra våra laddbara modeller och räkna på vad din nästa tjänstebil från Kia kommer att kosta.',
    titleClasses: 'font-medium text-2xl',
    textClasses: 'font-light',
    textContainerClasses: 'text-center',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/KIA_EV5_REAR_kalkylator.jpg',
      alt: 'En silverfärgad Kia EV5 parkerad på en vidsträckt, isbelagd yta i ett snöklätt fjällandskap under en blå skymningshimmel.',
      sizes: '(max-width: 768px) 100vw, 50vw',
    },
    link: {
      text: 'Räkna på din nästa tjänstebil',
      url: 'https://www.kia.com/se/tjanstebil/kalkyl-laddhybrid/',
      openInNewTab: false,
    },
  },
];

export const greyListEV5 = {
  title: 'Alltid i en Kia.',
  underTitle: 'Följande ingår som standard i alla nya personbilar från Kia: ',
  items: [
    { text: 'Rattvärme' },
    { text: 'Backkamera' },
    { text: 'Metallic/pearl-lack' },
    { text: 'Värmepump och förvärmning av batteri och kupé (i elbilar)' },
    { text: 'Kia Assistans i samband med Kia Originalservice¹⁴' },
    { text: '7 års nybilsgaranti från fabrik¹¹' },
    { text: '7 års app-styrning (Kia App¹³)' },
    { text: '7 års garanti på Kia Original vinterhjul (tillval)' },
    { text: '7 års uppkopplad navigation med live-tjänster (Kia Live)' },
  ],
};

export const infoColumns2EV5 = [
  {
    title: 'Bilmodeller.',
    text: 'Upptäck vårt breda modellprogram med laddbara bilar som passar alla.',
    titleClasses: 'font-medium text-2xl',
    textClasses: 'font-light',
    textContainerClasses: 'text-center',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/Kia_Fullrange_Final_4x3.jpg',
      alt: 'KIA Elbilar',
      sizes: '(max-width: 768px) 100vw, 50vw',
    },
    link: {
      text: 'Läs mer om våra bilmodeller',
      url: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
      openInNewTab: false,
    },
  },
  {
    title: 'Uppkopplade tjänster.',
    text: 'I Kia App kan du hantera allt som rör din bil - från att ruttplanera resor och fjärrstyra funktioner, till att boka service och hitta laddstationer. ',
    titleClasses: 'font-medium text-2xl',
    textClasses: 'font-light',
    textContainerClasses: 'text-center',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-mobile-guy.jpg',
      alt: '',
      sizes: '(max-width: 768px) 100vw, 50vw',
    },
    link: {
      text: 'Läs mer om Kia App',
      url: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/kia-app/',
      openInNewTab: false,
    },
  },
  {
    title: 'Kia Originaltillbehör.',
    text: 'Oavsett om du behöver en högkvalitativ dragkrok, lasthållare eller takbox erbjuder Kia tillbehör som är speciellt tillverkade och anpassade för din Kia.',
    titleClasses: 'font-medium text-2xl',
    textClasses: 'font-light',
    textContainerClasses: 'text-center',
    image: {
      src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-300x400-6_NY.jpg',
      alt: 'KIA Elbilar',
      sizes: '(max-width: 768px) 100vw, 50vw',
    },
    link: {
      text: 'Läs mer om Kia Originaltillbehör',
      url: 'https://www.kia.com/se/aga/originaldelar-oversikt/originaltillbehor/',
      openInNewTab: false,
    },
  },
];
